import { InjectionToken } from '@angular/core';

import { ScrollPositionRestorationConfig } from './scroll-position-restoration-config';

export const SCROLL_POSITION_RESTORATION_CONFIG_INJECTION_TOKEN = new InjectionToken<ScrollPositionRestorationConfig>(
  'scroll_position_restoration_config_injection_token',
);
